import React, { useState, useMemo, useEffect, ReactNode, useCallback } from "react";
import Header, { ColumnsItem } from "./BaseComponents/Header";
import Footer from "./BaseComponents/Footer";
import Main from "./BaseComponents/Main";
import { IProps as ItemProps } from "./BaseComponents/Item";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import "./index.less";
import events from "../../context/events";
import { isFocusEnv } from "@/utils";
import { debounce } from "lodash";
interface IProps {
  // columns: any[]; // 表头数据
  list: any[]; // 列表数据
  loading: boolean; // loading
  // isCheckbox: boolean; // 是否开启复选框
  // isDisabledListItem: boolean; // 是否开启禁用列表项
  isLoadMore: boolean; // 是否加载下一条
  // isFilters: boolean; // 是否开启过滤器
  pagination?: boolean | object; // 分页
  footerHeight?: number;
  defaultCheckedList?: string[];
  disabledHeader?: boolean; // 是否禁用表头 例如筛选等操作
  onButtom?: Function; // 加载下一条数据
  footerRender?: () => ReactNode;
  getCheckedIds?: (string: []) => void;
  folderFrom?: any;
  isGroupSpace?: boolean;
  from?: string; // 是哪个页面使用的
  isRoot?: boolean;
  diffHeight?: number;
  classNames?: string;
  isDataText?: boolean;
  showAI?: boolean;
}
const TableList = (props: IProps & ItemProps) => {
  const {
    columns,
    list,
    loading = true,
    pagination = false,
    // isDisabledListItem = false,
    disabledHeader = false,
    isLoadMore = false,
    // isFilters = false,
    footerRender,
    preOptions,
    afterOptions,
    renderActions,
    handleItem,
    contentRender,
    onButtom,
    footerHeight = 52,
    defaultCheckedList = [],
    getCheckedIds,
    folderFrom = {},
    from = "",
    isRoot = true,
    diffHeight = 0,
    allowDraggble,
    classNames,
    isDataText = true,
    showAI = true
  } = props;
  const { canDraggerUpload = true, draggerUploadShow = false } = folderFrom;
  const [checkedList, setCheckedList] = useState<string[]>(defaultCheckedList);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const reloadFn = useCallback(() => {
    setCheckedList([]);
    setIndeterminate(false);
    setCheckAll(false);
  }, []);
  useEffect(() => {
    events.on("list.check", reloadFn);
    return () => {
      events.off("list.check", reloadFn);
    };
  }, [reloadFn]);
  useMemo(() => {
    if (indeterminate || checkAll) {
      setIndeterminate(!!checkedList.length && checkedList.length < list.length);
      setCheckAll(checkedList.length === list.length);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);
  useEffect(() => {
    // 出现死循环 有点蒙
    if (defaultCheckedList.length === checkedList.length) {
      return;
    }
    setIndeterminate(defaultCheckedList.length < list.length ? true : false);
    setCheckAll(defaultCheckedList.length === list.length ? true : false);
    setCheckedList(defaultCheckedList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCheckedList]);
  const onCheckboxChange = (ids: any) => {
    setCheckedList(ids);
    setIndeterminate(!!ids.length && ids.length < list.length);
    setCheckAll(ids.length === list.length);
    getCheckedIds?.(ids);
  };
  const onCheckAllChange = (e: CheckboxChangeEvent) => {
    let ids: any = [];
    if (e.target.checked) {
      const reslut = columns.find((item: ColumnsItem) => item.checkbox);
      if (!reslut) {
        return;
      }
      for (let item of list) {
        if (!item.isDisabled) {
          ids.push(item[reslut.dataIndex]);
        }
      }
    }
    setCheckedList(e.target.checked ? ids : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
    getCheckedIds?.(ids);
  };
  // const height = useMemo(() => {
  //   if (isRoot) {
  //     return "auto";
  //   }
  //   let tmpH = 142 + diffHeight;
  //   if (checkedList.length > 0) {
  //     tmpH = tmpH + 50;
  //   }
  //   // console.log(isFocusEnv(), "isFocusEnv()===>");
  //   if (!isFocusEnv()) {
  //     const node = document.getElementsByClassName("notify-area") || [];
  //     node[0] && (tmpH += 40);
  //   }
  //   return `calc(100vh - ${tmpH}px)`;
  // }, [isRoot, checkedList, diffHeight]);
  const onScroll = useCallback(
    (event: any) => {
      if (!pagination || !isLoadMore || loading) {
        return;
      }
      const sTop = event.target?.scrollTop || 0;
      const cHight = event.target?.clientHeight || 0;
      const sHight = event.target?.scrollHeight || 0;
      const diff = sHight * 0.15;
      if (sTop + cHight >= sHight - diff) {
        onButtom?.();
      }
    },
    [pagination, isLoadMore, loading, onButtom]
  );
  useEffect(() => {
    if (!isRoot) {
      return;
    }
    const node: any = document.getElementsByClassName("myspace-list-wrap")[0];
    if (!node) {
      return;
    }
    node.addEventListener("scroll", onScroll);
    return () => {
      node.removeEventListener("scroll", onScroll);
    };
  }, [isRoot, onScroll, list]);
  return (
    <div className="joyspace-main-list" style={{ padding: isRoot ? 0 : "0 16px" }}>
      {/* {!isRoot && allowDraggble && (
        <div
          style={{
            width: "100%",
            height: "2px",
            background: "red",
            position: "absolute",
            top: "50px"
          }}
          onDragOver={(e) => {
            e.preventDefault();
            document.getElementById("tableWrapper")?.scrollBy(0, -10);
            message.info("over");
          }}
        />
      )} */}
      {!loading && (
        <Header
          disabledHeader={disabledHeader}
          onCheckAllChange={onCheckAllChange}
          indeterminate={indeterminate}
          checkAll={checkAll}
          columns={columns}
          from={from}
          isRoot={isRoot}
        />
      )}
      <div
        id="tableWrapper"
        className={showAI ? "joyspace-main joyspace-main-ai " : "joyspace-main"}
        style={{
          overflowY: isRoot ? "initial" : "auto",
          marginBottom: indeterminate || checkAll ? footerHeight : 0
        }}
        onScroll={(event: any) => {
          if (isRoot) {
            return;
          }
          onScroll(event);
        }}
      >
        <Main
          classNames={classNames}
          isLoadMore={isLoadMore}
          list={list}
          columns={columns}
          loading={loading}
          pagination={pagination}
          checkedList={checkedList}
          onButtom={() => {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            onButtom?.(true);
          }}
          hideBatchControl={reloadFn}
          preOptions={preOptions}
          afterOptions={afterOptions}
          renderActions={renderActions}
          handleItem={handleItem}
          onCheckboxChange={onCheckboxChange}
          contentRender={contentRender}
          canDrag={draggerUploadShow && canDraggerUpload}
          allowDraggble={allowDraggble}
          isDataText={isDataText}
        />
      </div>
      {/* {!isRoot && allowDraggble && (
        <div
          style={{
            width: "100%",
            height: "2px",
            background: "red",
            position: "absolute",
            bottom: 4
          }}
          onDragOver={(e) => {
            e.preventDefault();
            document.getElementById("tableWrapper")?.scrollBy(0, 10);
            message.info("over");
          }}
        />
      )} */}
      {(indeterminate || checkAll) && <Footer height={footerHeight} footerRender={footerRender} />}
    </div>
  );
};

export default TableList;
